/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Create store
  Date: April 2020
**/

import { createStore } from 'easy-peasy';
import storeModel from '../model';

const store = createStore(storeModel);

export default store;
